<template>
    <div class="table" v-if="uId">
        <div class="table-header">
            <h4 class="table-title text-center mt-3">{{title}}</h4>
        </div>
        <div class="text-left">
            <div id="search-input-container">
                <label v-if="search" autocomplete="off">
                    <input type="search" class="form-control mb-2" :placeholder="$t('templates.search')" name="search" v-model="searchInput" autocomplete="false">
                </label>

                <div v-if="this.exportable" class="actions float-right mb-3" v-b-tooltip.hover style="display: inline-block;" :title="$t('misc.export_excel')">
                    <a href="#" class="btn btn-info text-white" @click.prevent="exportExcel()">
                        <i class="fa fa-2x fa-file-excel-o"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table ref="table" class="table table-bordered table-hover">
                <thead>
                    <template v-if="grandTotal && grandTotalData">
                        <tr v-if="grandTotalData.values" v-for="(values, text) in this.grandTotalData.values">
                            <td :colspan="(grandTotalData.start+1)" align="right">{{$t(text)}}</td>
                            <td v-for="value in values">
                                {{value}}
                            </td>
                        </tr>
                        <tr v-if="grandTotalData.header">
                            <td :colspan="(grandTotalData.start+1)"></td>
                            <td v-for="value in this.grandTotalData.header" :colspan="value.colspan" align="center">
                                {{$t(value.text)}}
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <th v-for="(column, index) in columns" @click="sort(index, column)" :class="(column.sortable !== false  ? 'sortable' : '')
                            + (sortColumn === index ?
                                (sortType === 'desc' ? ' sorting-desc' : ' sorting-asc') : '')" :style="{width: column.width ? column.width : 'auto'}" :key="index">
                            {{ column.label}}
                            <i class="fa float-right" :class="(sortColumn === index ?
                                (sortType === 'desc' ? ' fa fa-angle-down' : ' fa fa-angle-up') : '')"></i>
                        </th>
                        <slot name="thead-tr"></slot>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, indextr) in paginated">
                        <tr @click="click(row, indextr)" :key="indextr">
                        <template v-for="(column,index) in columns">
                            <!--
                            <td :class="column.numeric ? 'numeric' : ''" v-if="column.html" v-html="collect(row, column.field, column)" :key="index">
                                <a href="#" v-if="column.clickable" @click.prevent="clickSpecificRow(row, index)">{{ collect(row, column.field, column) }}</a>
                            </td>
                            -->

                            <td v-if="column.showInput || column.showCheckBox || column.showHourGlassButton  || column.showPartsButton || column.showViewButton || column.showDeleteButton || column.showEditButton || column.showPermissionsButton || column.showRolesButton || column.showPricelistButton || column.showPDF || column.showPickup || column.showExpandButton" :key="index">
                                <template v-if="column.showInput">
                                    <input type="text" size="2" class="form-control m-1" :value="collect(row, column.field, column)" @keyup="enterInput(row, $event)">
                                </template>

                                <template v-if="column.showCheckBox">
                                    <input v-if="showCheckBoxCheckedModel" :value="row.id" v-model="showCheckBoxCheckedModel" type="checkbox" class="checkboxes m-1 sortable" @click="checkBox(row, index)">
                                    <input v-else type="checkbox" class="m-1 sortable" @click="checkBox(row, index)">
                                </template>

                                <template v-if="column.showViewButton">
                                    <i class='fa fa-2x fa-eye text-default m-1 sortable' @click="viewRow(row, index)"></i>
                                </template>

                                <span v-if="showEditButton(row, column)" v-b-tooltip.hover style="display: inline-block;" :title="$t('general.buttons.edit')">
                                    <template>
                                        <i class='fa fa-2x fa-pencil text-success m-1 sortable' @click="editRow(row, index)"></i>
                                    </template>
                                </span>

                                <template v-if="column.showHourGlassButton">
                                    <i class="fa fa-2x fa-hourglass-end text-default m-1 sortable" @click="hourGlassRow(row, index)"></i>
                                </template>

                                <span v-if="showPartsButton(row, column)" v-b-tooltip.hover style="display: inline-block;" :title="$t('general.buttons.welds')">
                                    <template>
                                        <i class="fa fa-2x fa-link text-default m-1 sortable" @click="partsRow(row, index)"></i>
                                    </template>
                                </span>

                                <template v-if="showDeleteButton(row, column)">
                                    <i class='fa fa-2x fa-trash text-danger m-1 sortable' @click="deleteRow(row, index)"></i>
                                </template>

                                <template v-if="column.showPermissionsButton">
                                    <i class='fa fa-2x fa-lock text-danger m-1 sortable' @click="permissionRow(row, index)"></i>
                                </template>

                                <template v-if="column.showRolesButton">
                                    <i class='fa fa-2x fa-user text-info m-1 sortable' @click="roleRow(row, index)"></i>
                                </template>

                                <template v-if="column.showCertificatesButton">
                                    <i class='fa fa-2x fa-graduation-cap text-dark m-1 sortable' @click="certificateRow(row, index)"></i>
                                </template>

                                <template v-if="column.showPricelistButton">
                                    <i class='fa fa-2x fa-money-bill text-info m-1 sortable' style="color:green !important" @click="priceRow(row, index)"></i>
                                </template>

                                <template v-if="column.showRevisionButton">
                                    <i class='fa fa-2x fa-list-alt text-info m-1 sortable' @click="revisionRow(row, index)"></i>
                                </template>

                                <template v-if="column.showItemButton">
                                    <i class='fa fa-2x fa-shopping-bag text-info m-1 sortable' @click="revisionItem(row, index)"></i>
                                </template>

                                <template v-if="column.showRequestButton">
                                    <i class='fa fa-2x fa-clipboard text-info m-1 sortable' @click="requestRow(row, index)"></i>
                                </template>
                                
                                <span v-if="showPDF(row, column)" v-b-tooltip.hover style="display: inline-block;" :title="$t('general.buttons.show_pdf')">
                                    <template>
                                        <i class='fa fa-2x fa-file-pdf-o text-default m-1 sortable' @click="viewPDF(row, index)"></i>
                                    </template>
                                </span>

                                <template v-if="column.showPickup">
                                    <i class='fa fa-2x fa-arrow-circle-up blue--text m-1 sortable' @click="viewPickup(row, index)"></i>
                                </template>
                            </td>

                            <td v-else-if="column.showFile" :key="index">
                                <template v-if="column.showFile">
                                    <i class='fa fa-2x fa-file text-default m-1 sortable' @click="viewFile(row, index)"></i>
                                </template>
                            </td>

                            <td v-else-if="column.showFileButton" :key="index">
                                <template v-if="column.showFileButton">
                                    <i title = "File" class='fa fa-2x fa-file m-1 sortable' @click="fileRow(row, index)"></i>
                                </template>
                            </td>

                            <td v-else-if="column.showAsCheck" :key="index">
                                <div v-if="row[column.field+'_max']"> <!-- for material management -->
                                    <i v-if="row[column.field+'_id'] > 0 && row[column.field+'_status'] != 'delivered'" class="fa fa-times red--text fa-2x cursor-pointer" @click="clickUnCheck(row, index, column.field)"></i>
                                    <i v-if="!row[column.field+'_id'] && row[column.field+'_count'] > 0 && row[column.field+'_max'] > row[column.field]" class="fa fa-check fa-2x green--text cursor-pointer" @click="clickCheck(row, index, column.field)"></i>
                                    <i v-if="row[column.field+'_count'] == 0 && row[column.field+'_max'] > row[column.field] && !row[column.field+'_id']" class="fa fa-2x fa-ban"></i>
                                    <i v-if="row[column.field+'_id'] && row[column.field+'_status'] == 'delivered'" class="fa fa-2x fa-arrow-circle-up blue--text"></i>
                                </div>
                                <div v-else @click="clickCheck(row, index, column.field)" class="cursor-pointer">
                                    <i v-if="row[column.field] == 1 && row[column.field] != null" class="fa fa-2x fa-check" :class="{'green--text': row[column.field] == 1}"></i>
                                    <i v-else class="fa fa-2x fa-times"></i>
                                </div>
                            </td>

                            <td v-b-toggle="'collapse'+indextr+uId" :class="column.numeric ? 'numeric' : ''" v-else :key="index">
                                <a href="#" v-if="column.clickable" @click.prevent="clickSpecificRow(row, index)">
                                    <span v-if="column.html" v-html="collect(row, column.field, column)">{{ collect(row, column.field, column) }}</span>
                                    <span v-else>{{ collect(row, column.field, column) }}</span>
                                </a>
                                <template v-else>
                                    {{ collect(row, column.field, column) }}
                                </template>
                            </td>
                        </template>
                        <slot name="tbody-tr" :row="row"></slot>
                        </tr>
                        <!-- <div v-if="index == Object.keys(paginated).length - 1" style="margin-top: 0.1px"></div> -->
                        <tr>
                            <td class="p-0 border-0" :colspan="columns.length">
                                <b-collapse :id="'collapse'+indextr+uId">
                                    <div class="mb-0 table-responsive">
                                        <table style="background-color:#f2f2f2;" ref="table" class="table table-bordered table-hover" v-if="row.collapsible_infos && Object.keys(row.collapsible_headers).length > 0">
                                            <thead v-if="row.collapsible_headers && Object.keys(row.collapsible_headers).length > 0">
                                                <template v-if="grandTotalItem">
                                                    <tr v-if="typeof grandTotalItemData.values != 'undefined'">
                                                        <td :colspan="(grandTotalItemData.start+1)" align="right" style="visibility: hidden;"></td>
                                                        <td v-for="(value, text) in grandTotalItemData.values" :colspan="value.colspan" align="center" class="text-center" :class="typeof value.class != 'undefined' ? value.class : ''">
                                                            {{$t(value.text)}}
                                                        </td>
                                                    </tr>
                                                </template>

                                                <tr>
                                                    <th v-for="(value, key) in row.collapsible_headers">
                                                        <span v-if="typeof value == 'object'">
                                                            {{$t(value.title)}}
                                                        </span>
                                                        <span v-else>{{$t(value)}}</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(valuesci, keyci) in row.collapsible_infos">
                                                    <td v-for="(value, key) in row.collapsible_headers" v-if="typeof valuesci[key] != 'undefined'" :style="{'min-width': value.type == 'action' ? '85px' : 'auto'}">
                                                        <span v-if="typeof value == 'object' && value.type == 'action'">
                                                            <i v-for="(v,k) in valuesci[key]" :class="v" @click="subRowClick(valuesci, k, v)"></i>
                                                        </span>

                                                        <span v-else-if="typeof value == 'object' && typeof value.checkbox != 'undefined' && value.checkbox == 1">
                                                            <i v-for="(v2,k2) in valuesci[key]" :class="v2" @click="rowCheckboxAutoUpdate(valuesci, value.type)"></i>
                                                        </span>

                                                        <span v-else-if="typeof value == 'object' && value.type == 'select' && value.can_change == 1">
                                                            <select 
                                                                class="form-control" 
                                                                style="min-width: 200px;"
                                                                :disabled="$store.state.ajax_in_progress" 
                                                                @change="changeSelect(row.collapsible_infos[keyci], key, valuesci[key])" 
                                                                v-model="valuesci[key]" 
                                                            >
                                                                <option v-for="(value2,key2) in rowChangeSelectOptions[key]" :value="value2.id">{{value2.name}}</option>
                                                            </select>
                                                        </span>

                                                        <span v-else-if="typeof value == 'object' && value.type == 'input' && value.can_change == 1">
                                                            <input 
                                                                class="form-control" 
                                                                style="min-width: 100px;" 
                                                                type="number" 
                                                                onKeyPress="if(this.value.length==6) return false;" 
                                                                step=".01" 
                                                                @change="changeUpdate(row.collapsible_infos[keyci], key, valuesci[key])"
                                                                v-model="valuesci[key]"
                                                                :disabled="$store.state.ajax_in_progress" 
                                                            />
                                                        </span>

                                                        <span v-else-if="typeof value == 'object' && value.type == 'text' && value.can_change == 1">
                                                            <textarea 
                                                                class="form-control" 
                                                                style="min-width: 150px;" 
                                                                type="text" 
                                                                maxlength="55"
                                                                :disabled="$store.state.ajax_in_progress"  
                                                                @change="changeUpdate(row.collapsible_infos[keyci], key, valuesci[key])"
                                                                v-model="valuesci[key]" 
                                                            >
                                                        </textarea>
                                                        </span>

                                                        <span v-else-if="typeof value == 'object' && value.type == 'textarea' && value.can_change == 1">
                                                            <textarea 
                                                                class="form-control" 
                                                                style="min-width: 150px;" 
                                                                type="text" 
                                                                maxlength="55" 
                                                                rows="2" 
                                                                :disabled="$store.state.ajax_in_progress" 
                                                                v-model="valuesci[key]"
                                                            >
                                                            </textarea>

                                                            <b-btn 
                                                                class="btn btn-dark btn-block mt-1" 
                                                                @click="changeUpdate(row.collapsible_infos[keyci], key, valuesci[key])"
                                                            >
                                                                {{$t('misc.save')}}
                                                            </b-btn>
                                                        </span>

                                                        <span v-else>{{valuesci[key]}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <h5 v-else>{{$t('misc.no_values')}}</h5>

                                        <table ref="table" class="table table-bordered table-hover" v-if="row.collapsible_infos2 && Object.keys(row.collapsible_infos2).length > 0">
                                            <thead v-if="row.collapsible_headers2 && Object.keys(row.collapsible_headers2).length > 0">
                                                <tr v-if="row.collapsible_title2">
                                                    <th :colspan="Object.keys(row.collapsible_headers2).length">
                                                        {{$t(row.collapsible_title2)}}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th v-for="(value, key) in row.collapsible_headers2">
                                                        {{$t(value)}}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(values, key) in row.collapsible_infos2">
                                                    <td v-for="(value,key2) in row.collapsible_headers2" v-if="typeof values[key2] != 'undefined'">
                                                        <span v-if="values[key2] && (values[key2]+'').indexOf('general.') === 0">{{$t(values[key2])}}</span>
                                                        <span v-else>{{values[key2]}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table ref="table" class="table table-bordered table-hover" v-if="row.collapsible_infos3 && Object.keys(row.collapsible_infos3).length > 0">
                                            <thead v-if="row.collapsible_headers3 && Object.keys(row.collapsible_headers3).length > 0">
                                                <tr v-if="row.collapsible_title3">
                                                    <th :colspan="Object.keys(row.collapsible_headers3).length">
                                                        {{$t(row.collapsible_title3)}}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th v-for="(value, key) in row.collapsible_headers3">
                                                        {{$t(value)}}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(values, key) in row.collapsible_infos3">
                                                    <td v-for="(value,key2) in row.collapsible_headers3" v-if="typeof values[key2] != 'undefined'">
                                                    <!--<td v-for="(value,key2) in values" v-if="typeof row.collapsible_headers3[key2] != 'undefined'">-->
                                                        <span v-if="typeof values[key2] == 'object' && values[key2].type == 'check' && values[key2].can_change == 1" @click="clickCheck(row.collapsible_infos3[key], key2, values[key2].value)" class="cursor-pointer">
                                                            <i v-if="values[key2].value== 1 && values[key2].value != null" class="fa fa-2x fa-check" :class="{'green--text': values[key2].value == 1}"></i>
                                                            <i v-else class="fa fa-2x fa-times"></i>
                                                        </span>
                                                        <span v-else-if="typeof values[key2] == 'object' && values[key2].type == 'check' && values[key2].can_change == 0">
                                                            <i v-if="values[key2].value== 1 && values[key2].value != null" class="fa fa-2x fa-check" :class="{'green--text': values[key2].value == 1}"></i>
                                                            <i v-else class="fa fa-2x fa-times"></i>
                                                        </span>
                                                        <span v-else-if="typeof values[key2] == 'object' && values[key2].type == 'text' && values[key2].can_change == 1">
                                                            <textarea class="form-control" rows="2" type="text" maxlength="255" v-model="values[key2].value"></textarea>
                                                            <b-btn class="btn btn-dark btn-block mt-1" @click="changeUpdate(row.collapsible_infos3[key], key2, values[key2].value)">{{$t('misc.save')}}</b-btn>
                                                        </span>
                                                        <span v-else>{{values[key2]}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-collapse>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <div class="table-footer" v-if="paginate">
            <paginate
                ref="pagination"
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'&laquo;'"
                :next-text="'&raquo;'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class= "'page-link'"
                :next-link-class= "'page-link'"
                :prev-link-class= "'page-link'"
                class="mt-3 float-right">
            </paginate>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VuejsPaginate from 'vuejs-paginate';

export default {
    name: 'DataTableCollapse',
    components: {
        VuejsPaginate,
    },
    props: {
        grandTotal: {
            default: false
        },
        grandTotalData: {
            type: Object,
            required: false,
        },
        grandTotalItem: {
            default: false
        },
        grandTotalItemData: {
            type: Object,
            required: false,
        },
        title: {
            default: ""
        },
        columns: {
            required: true
        },
        rows: {
            required: true
        },
        perPage: {
            default: 10
        },
        pageCount: {
            default: 1
        },
        rowsCount: {
            default: 0
        },
        sortable: {
            default: true
        },
        search: {
            default: true
        },
        paginate: {
            default: true
        },
        exportable: {
            default: true
        },
        showCheckBoxCheckedModel: {
            type: Array,
            default () {
                return []
            }
        },
        rowChangeSelectOptions: {
            type: Object,
            default () {
                return null;
            }
        }
    },

    data() {
        return {
            currentPage: 1,
            currentPerPage: this.perPage,
            sortColumn: -1,
            sortType: 'asc',
            searchInput: '',
            lastInput: '',
            page: 1,
            currentRow: null,
            uId: null,
        }
    },
    mounted() {
        this.uId = this.uuid();
        this.sort(0)
    },
    methods: {
        showPDF(row, column) {
            if (typeof (row.show_pdf) != 'undefined') {
                return row.show_pdf;
            } else {
                return column.showPDF;
            }
        },
        showPartsButton(row, column) {
            if (typeof (row.show_parts_button) != 'undefined') {
                return row.show_parts_button;
            } else {
                return column.showPartsButton;
            }
        },
        showEditButton(row, column) {
            if (typeof (row.show_edit_button) != 'undefined') {
                return row.show_edit_button;
            } else {
                return column.showEditButton;
            }
        },
        showDeleteButton(row, column) {
            if (typeof (row.show_delete_button) != 'undefined') {
                return row.show_delete_button;
            } else {
                return column.showDeleteButton;
            }
        },

        click(row, index) {
            this.currentRow = index;
            this.$emit("rowClick", row, index);
        },

        clickSpecificRow(row, index) {
            this.$emit('clickSpecificRow', row, index);
        },

        subRowClick(row, action) {
            this.$emit('subRowClick', row, action);
        },

        rowCheckboxAutoUpdate(row, action) {
            this.$emit('rowCheckboxAutoUpdate', row, action);
        },

        checkBox (row, index) {
            this.$emit('rowCheckBox', row, index);
        },

        enterInput (row, $event) {
            this.$emit('rowEnterInput', row, $event.target.value);
        },

        viewPDF (row, index) {
            if (!this.$store.state.ajax_in_progress) {
                this.$emit('rowClickPDF', row, index);
            }
        },

        viewFile (row, index) {
            this.$emit('rowClickFile', row, index);
        },

        hourGlassRow(row, index) {
            this.$emit('rowClickHourGlass', row, index);
        },

        partsRow(row, index) {
            this.$emit('rowClickParts', row, index);
        },

        viewRow(row, index) {
            this.$emit('rowClickView', row, index);
        },

        viewPickup(row, index) {
            this.$emit('rowClickPickup', row, index);
        },

        deleteRow(row, index) {
            this.$emit('rowClickDelete', row, index);
        },

        permissionRow(row, index) {
            this.$emit('rowClickPermission', row, index);
        },

        roleRow(row, index) {
            this.$emit('rowClickRole', row, index);
        },

        priceRow(row, index) {
            this.$emit('rowClickPricelist', row, index);
        },

        revisionRow(row, index) {
            this.$emit('rowClickRevision', row, index);
        },

        itemRow(row, index) {
            this.$emit('rowClickItem', row, index);
        },

        requestRow(row, index) {
            this.$emit('rowClickRequests', row, index);
        },

        certificateRow(row, index) {
            this.$emit('rowClickCertificate', row, index);
        },

        fileRow(row, index) {
            this.$emit('rowClickFile', row, index);
        },

        clickCheck(row, index, column) {
            this.$emit('rowClickCheck', row, index, column);
        },

        clickUnCheck(row, index, column) {
            this.$emit('rowUnClickCheck', row, index, column);
        },

        changeSelect(row, index, column) {
            this.$emit('rowChangeSelect', row, index, column);
        },
        
        changeUpdate(row, index, value) {
            this.$emit('rowChangeUpdate', row, index, value);
        },

        editRow(row, index) {
            this.$emit('rowClickEdit', row, index);
        },

        //Table
        clickCallback (page) {
            this.$emit('changePage', page);
        },
        sort(index, column) {
            if (column) {
                this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
                this.$emit('orderByEvent', column, this.sortType);
            } else {
                return;
            }
        },
        exportExcel() {
            if (!this.$store.state.ajax_in_progress) {
                this.$emit('exportButtonClick');
            }
        },
        renderTable() {
            var table = '<table><thead>';

            table += '<tr>';
            for (var i = 0; i < this.columns.length; i++) {
                const column = this.columns[i];
                table += '<th>';
                table += column.label;
                table += '</th>';
            }
            table += '</tr>';

            table += '</thead><tbody>';

            for (var i = 0; i < this.rows.length; i++) {
                const row = this.rows[i];
                table += '<tr>';
                for (var j = 0; j < this.columns.length; j++) {
                    const column = this.columns[j];
                    table += '<td>';
                    table += this.collect(row, column.field);
                    table += '</td>';
                }
                table += '</tr>';
            }

            table += '</tbody></table>';

            return table;
        },
        dig(obj, selector, type) {
            var result = obj;
            const splitter = selector.split('.');
            for (let i = 0; i < splitter.length; i++) {
                if (typeof (result) === 'undefined') {
                    return undefined;
                } else {
                    result = result[splitter[i]];
                    if (typeof type.numeric != 'undefined') {
                        if (type.numeric) {
                            result = this.$options.filters.currency(result);
                        }
                    }
                    if (typeof type.datetime != 'undefined') {
                        if (type.datetime) {
                            result = this.$options.filters.formatDateTime(result);
                        }
                    }
                }
            }
            return result;
        },
        collect(obj, field, type) {
            if (typeof (field) === 'function') {
                return field(obj);
            }
            else if (typeof (field) === 'string') {
                return this.dig(obj, field, type);
            }
            else {
                return undefined;
            }
        },
        uuid() {
            var uuidValue = "", k, randomValue;
            for (k = 0; k < 32;k++) {
                randomValue = Math.random() * 16 | 0;

                if (k == 8 || k == 12 || k == 16 || k == 20) {
                uuidValue += "-"
                }
                uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            }
            return uuidValue;
        }
    },
    computed: {
        processedRows: function () {
            var computedRows = this.rows;

            if (this.sortable !== false) {
                computedRows = computedRows.sort((x, y) => {
                    if (!this.columns[this.sortColumn]) {
                        return 0;
                    }

                    const cook = (x) => {
                        x = this.collect(x, this.columns[this.sortColumn].field);
                        if (typeof (x) === 'string') {
                            x = x.toLowerCase();
                            if (this.columns[this.sortColumn].numeric)
                                x = x.indexOf('.') >= 0 ? parseFloat(x) : parseInt(x);
                        }
                        return x;
                    }

                    x = cook(x);
                    y = cook(y);

                    return (x < y ? -1 : (x > y ? 1 : 0)) * (this.sortType === 'desc' ? -1 : 1);
                })
            }

            if (this.searchInput) {

                if(this.lastInput !== this.searchInput) {
                    this.lastInput = this.searchInput;
                }
            }
            return computedRows;
        },
        paginated: function () {
            var paginatedRows = this.processedRows;
            if (this.paginate && this.currentPerPage != -1) {
                paginatedRows = paginatedRows.slice((this.currentPage - 1) * this.currentPerPage, this.currentPage *
                    this.currentPerPage);
            }
            return paginatedRows;
        }
    },
    watch: {
        currentPerPage() {
            this.currentPage = 1;
            this.paginated;
        },
        searchInput() {
            this.$emit('searchEvent', this.searchInput);
            this.currentPage = 1;
            this.paginated;
            if (typeof this.$refs.pagination != 'undefined') this.$refs.pagination.selectFirstPage();
        }
    },
}
</script>

<style scoped>
    .table {
        margin-bottom: 0 !important;
    }

    .sortable {
        cursor: pointer;
    }

    .pagination1 {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
    }

    .pagination1 li {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
    }

</style>

<style>
    #specialDropdown button {
        padding: 0!important;
        border: none!important;
        width: 22.5px!important;
        height: 28px!important;
    }

    #specialDropdown {
        width: 22.5px!important;
        height: 28px!important;
        position: relative!important;
        bottom: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/tables/datatables/DataTableCollapse.vue